//      
import { invariant } from '../../../invariant';
import { completeDrop } from '../../action-creators';
                                            
                                                                           

export default (store                 ) => (next          ) => (
  action        ,
)      => {
  if (action.type !== 'DROP_ANIMATION_FINISHED') {
    next(action);
    return;
  }

  const state        = store.getState();
  invariant(
    state.phase === 'DROP_ANIMATING',
    'Cannot finish a drop animating when no drop is occurring',
  );
  store.dispatch(completeDrop({ completed: state.completed }));
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/middleware/drop/drop-animation-finish-middleware.js